import CopyTextButton from 'v3/common/components/CopyTextButton';
import PortalToTarget from 'v3/common/components/PortalToTarget';

const oneIndentation = ' ';

const AngelBroking = () => (
  <div id="stepper__container">
    <PortalToTarget targetClassName="login-modal__header" allowForWeb>
      <h3>Angel Broking API and Secret Key Setup</h3>
    </PortalToTarget>

    <div className="stepper">
      <li className="stepper_item" data-stepper="1">
        <div className="stepper_content">
          <p>
            Open the <b>Angel One Smart API{oneIndentation}</b>
            <a
              className="text-decoration-underline"
              href="https://smartapi.angelbroking.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {oneIndentation}website{oneIndentation}
            </a>
            and click <b>Login for Smart API</b>.
          </p>
          <img src="/images/broker_setup_guide/angle_broking/step_1.png" className="w-100" alt="Home Page" />
        </div>
      </li>

      <li className="stepper_item" data-stepper="2">
        <div className="stepper_content">
          <p>
            Choose a <b>login method</b> and complete the login process.
          </p>
          <img src="/images/broker_setup_guide/angle_broking/step_2.png" className="w-100" alt="Login Page" />
        </div>
      </li>
      <li className="stepper_item" data-stepper="3">
        <div className="stepper_content">
          <p>
            After logging in, click <b>My Profile</b> and select <b>My APIs</b>.
          </p>
        </div>
      </li>
      <li className="stepper_item" data-stepper="4">
        <div className="stepper_content">
          <p>
            Choose <b>+ </b> <b>ADD APP.</b>
          </p>
          <img src="/images/broker_setup_guide/angle_broking/step_3.png" className="w-100" alt="Add App" />
        </div>
      </li>
      <li className="stepper_item" data-stepper="5">
        <div className="stepper_content">
          <p>
            Now, you have to <b>fill in</b> the boxes.
          </p>
          <div className="stepper__form">
            <div className="stepper__form-group">
              <h6>App Name:</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="Quantman" disabled />
                </span>
                <CopyTextButton text="Quantman" />
              </div>
            </div>

            <div className="stepper__form-group">
              <h6>Redirect URL: </h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input
                    type="text"
                    placeholder="https://quantman.trade/auth/angle_broking/callback"
                    disabled
                  />
                </span>
                <CopyTextButton text="https://quantman.trade/auth/angle_broking/callback" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Post Back URL: </h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input
                    type="text"
                    placeholder="https://quantman.trade/auth/angle_broking/postback"
                    disabled
                  />
                </span>
                <CopyTextButton text="https://quantman.trade/auth/angle_broking/postback" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Primary Static IP: </h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="Contact QuantMan Support" disabled />
                </span>
              </div>
            </div>
          </div>
        </div>
      </li>

      <li className="stepper_item" data-stepper="6">
        <div className="stepper_content">
          <p>
            After entering all, <b>tap ADD</b>. Thus, you have successfully created an <b>API Key</b> and{' '}
            <b>Secret Key</b>.
          </p>
        </div>
      </li>

      <li className="stepper_item" data-stepper="7">
        <div className="stepper_content">
          <p>
            Copy both<b>(API Key & Secret Key)</b> and come to the <b>QuantMan website</b>.
          </p>
        </div>
      </li>

      <li className="stepper_item" data-stepper="8">
        <div className="stepper_content">
          <p>
            Click the <b>Back</b> button to return to the login section. Enter the <b>Client ID</b> again and
            press <b>Validate</b>.
          </p>
          <img src="/landing-page-img/brokers-img/last-step.png" alt="Angle Broking fill form" />
        </div>
      </li>

      <li className="stepper_item" data-stepper="9">
        <div className="stepper_content">
          <p>
            Then, <b>paste</b> the <b>API Key & Secret key</b> that you copied.
          </p>
          <img
            src="/images/broker_setup_guide/angle_broking/step_4.png"
            className="w-100"
            alt="Angle Broking fill form"
          />
        </div>
      </li>

      <li className="stepper_item" data-stepper="10">
        <div className="stepper_content">
          <p>
            Following it, enter <b>PIN, TOTP</b> and click <b>Login.</b>
          </p>
        </div>
      </li>
    </div>
  </div>
);

export default AngelBroking;
